import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const ButtleFlowStep3 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <section>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gameflow button'
                    src={`${process.env.PUBLIC_URL}/images/system/system-step3-fr.webp`}
                />
            </div>{' '}
            <div className='flex justify-center mt-12'>
                <img
                    className=''
                    alt='One more'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-skills-fr.webp`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                <p className=' '>
                    Vous pouvez <span className='text-pborange'>attaquer</span> soit à mains nues, soit avec un objet
                    dont vous vous êtes équipé. Si vous sélectionnez <span className='text-pborange'>Capacités</span>,
                    une liste des capacités s'affichera. En plus des capacités d'attaque,{' '}
                    <span className='text-pborange'>les capacités de soin</span> sont également accessibles à partir de
                    ce menu.
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-3',
                            index: 1,
                        },
                        {
                            modalId: 'flow-3',
                            index: 2,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="Les personnages se trouvant à l'intérieur de la zone d'effet seront les cibles de la capacité. Les ennemis comme les alliés seront affectés s'ils se trouvent à l'intérieur de la zone, alors faites attention !"
                />{' '}
                <p className=' '>
                    En plus des armes, les personnages{' '}
                    <span className='text-pborange'>
                        peuvent aussi s'équiper avec l'herbe et les arbres présents sur les cartes
                    </span>{' '}
                    ! <span className='text-pborange'>Leurs capacités dépendront</span> de ce dont ils s'équipent.
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-3',
                            index: 3,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="Ce brin d'herbe a beau sembler tout à fait ordinaire, il dispose en réalité d'une puissante capacité, capable d'infliger plus de dégâts qu'un personnage à mains nues !"
                />{' '}
                <p className=' '>
                    Avant que vous exécutiez une attaque sur un ennemi, une{' '}
                    <span className='text-pborange'>prévision des dégâts</span> s'affichera. Consultez cette prévision
                    et réfléchissez à la meilleure stratégie d'attaque. Il se peut que l'attaque causant le plus de
                    dégâts ne soit pas celle que vous croyez !
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-3',
                            index: 4,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="Vous pouvez infliger d'importants dégâts en attaquant à l'aide d'un élément face auquel l'ennemi est vulnérable, ou à l'aide d'autres techniques !"
                />{' '}
            </div>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={4}
            />
        </section>
    )
}
